/**
 * @generated SignedSource<<5ba6b9f0e5a607b75229f9601d9e5bbb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhotoRailContainer_searchBrowsePhoto$data = {
  readonly creators: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"PhotoRailContainer_creators">;
  } | null> | null;
  readonly tags: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"PhotoRailContainer_tags">;
  } | null> | null;
  readonly " $fragmentType": "PhotoRailContainer_searchBrowsePhoto";
};
export type PhotoRailContainer_searchBrowsePhoto$key = {
  readonly " $data"?: PhotoRailContainer_searchBrowsePhoto$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhotoRailContainer_searchBrowsePhoto">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhotoRailContainer_searchBrowsePhoto",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TradePhotoTag",
      "kind": "LinkedField",
      "name": "tags",
      "plural": true,
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "PhotoRailContainer_tags",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "SimilarItemsResults",
              "kind": "LinkedField",
              "name": "similarItems",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Item",
                  "kind": "LinkedField",
                  "name": "items",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "RailTag_tag"
            }
          ],
          "args": null,
          "argumentDefinitions": []
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PhotoCreator",
      "kind": "LinkedField",
      "name": "creators",
      "plural": true,
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "PhotoRailContainer_creators",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 4
                }
              ],
              "concreteType": "Item",
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "RailCreator_items"
                }
              ],
              "storageKey": "items(first:4)"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "RailCreator_creator"
            }
          ],
          "args": null,
          "argumentDefinitions": []
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PhotosSearchBrowsePhoto",
  "abstractKey": null
};
})();

(node as any).hash = "a63db1def2b2500923c2e49ae73fbba2";

export default node;
